<div
  class="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-200"
>
  <div class="flex items-center justify-between">
    <div class="flex-1">
      <h3 class="text-sm font-medium text-gray-600 mb-2">{{ data.title }}</h3>
      <p class="text-3xl font-bold text-gray-900">{{ data.value }}</p>
    </div>

    <div
      class="w-12 h-12 rounded-full flex items-center justify-center"
      [style.backgroundColor]="'#faf5f5'"
      [style.border]="'1px solid ' + (data.borderColor || '#E54C5D')"
    >
      <i
        [class]="data.icon + ' text-xl'"
        [style.color]="data.textColor || '#6b7280'"
      ></i>
    </div>
  </div>
</div>
